import React from 'react';
import Dots from '../../../atoms/Dots/Dots';

type TechStackSectionProps = {
  techStackSection?: {
    label?: string;
    title?: string;
    stacks?: Array<{
      title?: string;
      items?: string[];
    }>;
  };
};

const TechStackSection = ({ techStackSection }: TechStackSectionProps) => {
  if (!techStackSection) return null;

  const { label, title, stacks = [] } = techStackSection;

  return (
    <section className="px-4 pt-2 pb-14 md:pt-4 md:pb-20">
      <div className="max-w-[2400px] mx-auto px-4 md:px-8 lg:px-16 xl:px-24 2xl:px-32 3xl:px-48">
        <div className="text-center">
          <div className="text-[12px] md:text-[13px] xl:text-[15px] 2xl:text-[17px] 3xl:text-[22px] font-medium tracking-[0.28em] text-[var(--color-primary)] uppercase">
            {label}
          </div>
          <div className="mt-3 text-[34px] sm:text-[40px] md:text-[44px] xl:text-[52px] 2xl:text-[64px] 3xl:text-[80px] leading-[1.1] font-semibold text-white">
            {title}
          </div>
          <Dots width="w-4.5 md:w-5" height="h-4.5 md:h-5" className="mt-4 justify-center gap-4" />
        </div>

        <div className="mt-8 mx-auto max-w-[1440px] 3xl:max-w-[2200px] grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 3xl:grid-cols-4 gap-4 xl:gap-6 2xl:gap-6 3xl:gap-12">
          {stacks.map((stack) => {
            return (
              <div
                key={stack.title}
                className="group relative overflow-hidden rounded-[18px] px-4 py-4 md:px-5 md:py-5 xl:px-6 xl:py-6 2xl:px-6 2xl:py-6 3xl:px-14 3xl:py-14 min-h-[106px] md:min-h-[124px] xl:min-h-[136px] 2xl:min-h-[136px] 3xl:min-h-[300px] bg-[#1E2125] border border-[#0E4E85] transition duration-300 hover:bg-[var(--color-primary)] hover:border-[var(--color-primary)] hover:shadow-[0_12px_30px_rgba(34,156,255,0.18)]"
              >
                <div className="absolute left-3 right-3 bottom-0 h-[2px] bg-white/90 scale-x-0 origin-center transition duration-300 group-hover:scale-x-100" />
                <div className="text-[14px] md:text-[18px] xl:text-[20px] 2xl:text-[20px] 3xl:text-[40px] font-semibold text-white/90 transition duration-300 group-hover:text-white">
                  {stack.title}
                </div>
                <div className="mt-3 space-y-1 text-[11px] md:text-[14px] xl:text-[16px] 2xl:text-[16px] 3xl:text-[28px] leading-[1.35] 3xl:leading-[1.45] text-white/55 transition duration-300 group-hover:text-white/80">
                  {(stack.items ?? []).map((item) => (
                    <div key={item}>- {item}</div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechStackSection;
